import {createFileRoute} from '@tanstack/react-router';

import {CreateLayerTemplateForm} from '@/features/Library/components/Location/CreateLayerTemplateForm';

export const Route = createFileRoute(
  '/_b/_p/_library/locations_/$layoutTemplateId/create'
)({
  component: CreateLayerTemplateForm,
});
